import axios from 'axios';

/** Re-throw an axios error carrying the API's `message`, so callers/UI see the real reason. */
export function apiError(err: unknown, fallback: string): Error {
  if (axios.isAxiosError(err) && err.response?.data?.message) {
    return new Error(err.response.data.message as string);
  }
  return err instanceof Error ? err : new Error(fallback);
}

/** API error that also carries the server's `error` slug, for callers that branch on it. */
export class ApiRequestError extends Error {
  readonly slug?: string;
  /** From the response body's `attempts_remaining`, when the API includes it (e.g. code-confirmation flows). */
  readonly attemptsRemaining?: number;

  constructor(message: string, slug?: string, attemptsRemaining?: number) {
    super(message);
    this.name = 'ApiRequestError';
    this.slug = slug;
    this.attemptsRemaining = attemptsRemaining;
  }
}

/** Like {@link apiError}, but preserves the API's `error` slug (e.g. 'possible_desync'). */
export function apiRequestError(err: unknown, fallback: string): Error {
  if (axios.isAxiosError(err) && err.response?.data?.message) {
    const slug = err.response.data.error;
    const attemptsRemaining = err.response.data.attempts_remaining;
    return new ApiRequestError(
      err.response.data.message as string,
      typeof slug === 'string' ? slug : undefined,
      typeof attemptsRemaining === 'number' ? attemptsRemaining : undefined
    );
  }
  return err instanceof Error ? err : new Error(fallback);
}
